import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHousingHistoryTierLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#hhTierLightFilter)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M5.99873 0.625003L5.99978 0.625H6.00149C6.20859 0.625 6.37649 0.792895 6.37649 1V9.70155L4.20328 11.0368C3.6382 11.3734 3.01618 11.5217 2.561 11.1871C2.10737 10.8537 2.05866 10.2159 2.20567 9.57269L2.56014 8.02736L2.56035 8.02639C2.62399 7.74891 2.47995 7.53346 2.39998 7.46043L1.16102 6.21123L1.16053 6.21074C0.746329 5.79574 0.516891 5.28522 0.673503 4.79395C0.830256 4.30225 1.3131 4.01987 1.88917 3.92306L3.48399 3.6559C3.58205 3.64259 3.80656 3.55875 3.92008 3.32983L4.79965 1.55619C5.06303 1.02252 5.47537 0.626457 5.99873 0.625003Z",
			fill: "url(#hhTierLightPaint0)"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M7.33317 2.65455C7.51872 2.56254 7.74372 2.63836 7.83573 2.8239L8.08799 3.33258C8.11475 3.38767 8.17823 3.46527 8.2733 3.53634C8.36818 3.60728 8.45995 3.64588 8.51837 3.65601L8.51888 3.6561L10.1124 3.92303C10.6888 4.0199 11.1707 4.30262 11.3266 4.79463C11.4819 5.2852 11.2532 5.79532 10.8416 6.21032L9.60175 7.46043C9.55264 7.50994 9.49763 7.60321 9.46314 7.72472C9.42887 7.84541 9.42583 7.95534 9.44137 8.02637L9.44159 8.02736L9.79598 9.57236C9.94348 10.215 9.8923 10.8516 9.43898 11.1851C8.98377 11.52 8.36251 11.3743 7.79809 11.0366L7.30758 10.7438C7.12974 10.6377 7.07163 10.4075 7.17777 10.2296C7.28392 10.0518 7.51413 9.99368 7.69197 10.0998L8.18284 10.3928C8.6883 10.6953 8.92731 10.6304 8.99453 10.581C9.06365 10.5301 9.19746 10.3173 9.06499 9.74013L8.70945 8.19011C8.66024 7.96875 8.68234 7.7288 8.74165 7.51988C8.80089 7.31122 8.90837 7.09449 9.06924 6.93229L10.3091 5.68218C10.6274 5.36123 10.6462 5.13035 10.6116 5.02108C10.5774 4.91323 10.4317 4.73721 9.98827 4.66269L8.39364 4.39557L8.39231 4.39534C8.18573 4.35997 7.98528 4.25744 7.82422 4.13704C7.66349 4.01688 7.50741 3.85306 7.4141 3.66182L7.16382 3.15711C7.0718 2.97156 7.14763 2.74656 7.33317 2.65455Z",
			fill: "url(#hhTierLightPaint1)"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "hhTierLightFilter",
			x: .624023,
			y: .625,
			width: 10.752,
			height: 14.65,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.95 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_hh_tier_light"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "hhTierLightPaint0",
			x1: 12.3131,
			y1: 9.81308,
			x2: -2.22039,
			y2: -7.74445,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E6007E" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "hhTierLightPaint1",
			x1: 12.3131,
			y1: 9.81308,
			x2: -2.22039,
			y2: -7.74445,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E6007E" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white"
			})]
		})
	] })]
});
export default SvgHousingHistoryTierLight;
